import { Alert, Platform } from 'react-native';
import { toCamelCaseLabel } from './camelCaseLabel';

type LogoutHandlers = {
  onConfirm: () => void | Promise<void>;
  title?: string;
  message?: string;
};

export function confirmLogout({
  onConfirm,
  title = 'Log out',
  message = 'Are you sure you want to log out of this device?',
}: LogoutHandlers) {
  const heading = toCamelCaseLabel(title);
  const confirmLabel = toCamelCaseLabel('Log out');
  if (Platform.OS === 'web') {
    // React Native Web intentionally implements Alert.alert as a no-op.
    // Use the browser dialog so the confirmation action is reachable.
    const browser = globalThis as unknown as {
      confirm?: (prompt: string) => boolean;
    };
    if (browser.confirm?.(`${heading}\n\n${message}`)) {
      Promise.resolve(onConfirm()).catch(() => undefined);
    }
    return;
  }

  Alert.alert(heading, message, [
    { text: 'Cancel', style: 'cancel' },
    {
      text: confirmLabel,
      style: 'destructive',
      onPress: () => {
        Promise.resolve(onConfirm()).catch(() => undefined);
      },
    },
  ]);
}
